import type { CheckboxProps } from '@mui/material';
import { Checkbox } from '@mui/material';
import * as React from 'react';
import type { FormikProps } from 'formik';

import type { JSX } from 'react';

interface IProps<T extends string, V> extends CheckboxProps {
  name: T;
  formik: FormikProps<V>;
}
export const FCheckbox = <
  Field extends string,
  V extends { [key in Field]: unknown }
>({
  name,
  formik,
  ...props
}: IProps<Field, V>): JSX.Element => {
  return (
    <Checkbox
      name={name}
      value={formik.values[name]}
      checked={formik.values[name] as boolean}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      {...props}
    />
  );
};
